import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";

// Packages
import { Helmet } from 'react-helmet';

// API
import * as API  from '../../../utils/api';

// Actions
import {
  socialLogIn,
  updateUserState,
} from '../../../actions/user';

import {
  setActiveProfile,
} from '../../../actions/activeProfile';

import {
  updateForm,
} from '../../../actions/onboarding';

import {
  getProfileAccountDetails
} from '../../../actions/accountDetails';

// Components
import FormInput from '../../../components/Global/Forms/FormInput';
import MaskedFormInput from '../../../components/Global/Forms/MaskedFormInput';
import SelectFormInput from '../../../components/Global/Forms/SelectFormInput';
import FlashMessage from '../../../components/Global/FlashMessage';
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader';

// Utils
import {
  getAllUrlParams,
  isValidPhoneNumber,
  getStrippedNumberFromString,
} from '../../../utils/helpers';

class CompleteTwitterSignUpForm extends Component {
  state = {
    input: {
      athlete_first_name: '',
      athlete_last_name: '',
      athlete_email: '',
      athlete_phone_number: '',
      parent_first_name: '',
      parent_last_name: '',
      parent_phone_number: '',
      parent_email: '',
      twitter_id: '',
      role: 'athlete'
    },
    formErrors: {
      phone_number: '',
    },
    options: {
      role: [
        {value: 'athlete', label: 'High School Athlete'},
        {value: 'parent', label: 'Parent / Guardian'}
      ]
    },
    signUpErrorMessage: '',
    formIsValid: false,
    displayErrorMessages: false,
    flashMessage: {
      status: 'default',
      message: 'Please complete the following information to finish creating your account via Twitter.'
    },
    isLoading: true,
    isSubmitting: false,
  }

  componentDidMount() {
    const params = getAllUrlParams(window.location.href)

    if (params.oauth_token) {
      API.twitterUserDetails(params.oauth_token, params.oauth_verifier)
      .then(response => {
        if (response.jwt) {
          this.logInUser(response.user, response.jwt);
        } else {
          // If a user does not have a maintainer account,
          // update the input fields and have them finish creating an account
          this.setState(state => ({
            ...state,
            isLoading: false
          }), () => this.updateCurrentUser(response))
        }
      })
    } else if (params.denied) {
      this.props.handleFormChange(`twitter-denied`, 'complete-twitter-sign-up');
    } else {
      console.log('there was an error that was not caught in CompleteTwitterSignUpForm.js')
    }
  }

  logInUser(user, token) {
    // If a user has a LL account, add their auth token
    // to this object for use in log in
    let userForLogin = {
      ...user,
      auth_token: token,
    }

    // Check to see if user is a maintainer of any profiles.
    // If they aren't, that means that they've requested access
    // to a profile and are waiting to be accepted.
    const maintainedProfiles = userForLogin.maintained_profiles;

    if (maintainedProfiles.length > 0) {
      // Get the first username maintained for storage in Redux store.
      const username = maintainedProfiles[0].username

      this.initalizeReduxAndLogIn(userForLogin, username)
    } else {
      this.props.socialLogIn(userForLogin)
      if (userForLogin.role === 'athlete') {
        // If user is an athlete and doesn't maintain a profile yet,
        // send them back into onboarding.
        this.props.history.push('/sign-up/athlete-info-continue');
        this.props.handleFormChange('athlete-info-continue', 'complete-twitter-sign-up');
      } else {
        // User is a parent/guardian without any maintaine profiles.
        // Push them back into onboarding flow
        this.props.handleFormChange('connect-account-continue', 'complete-twitter-sign-up');
      }
    }
  }

  initalizeReduxAndLogIn(user, currentAthleteUsername) {
    //////////////////////////////////////////////////////////////
    // Set the `currentAthlete` redux object to the first
    // maintained profile of the user logging in.
    //////////////////////////////////////////////////////////////

    this.props.setActiveProfile(currentAthleteUsername)
    .then(response => {
      if (response.success) {
        this.props.setReduxAccountDetails(user, currentAthleteUsername)
        .then(response => { this.completeUserWithMaintainedProfilesLogin(user) })
      }
    })
  }

  completeUserWithMaintainedProfilesLogin(user) {
    //////////////////////////////////////////////////////////////
    // Complete logging in by setting a `reduxLogInComplete` flag on
    // our Redux user.
    //
    // This lets other components know that all Redux
    // and API functions have completed successfully and we have
    // the expected data to run off of.
    //////////////////////////////////////////////////////////////
    let completedLogInUser  = {...user}

    completedLogInUser.reduxLogInComplete = true

    this.props.updateReduxUser(completedLogInUser)
    this.props.socialLogIn(completedLogInUser)
  }


  updateCurrentUser = (userAttributes) => {
    let updatedUser = {
      first_name: userAttributes.first_name,
      last_name: userAttributes.last_name,
      email: userAttributes.email,
    }

    this.props.updateReduxUser(updatedUser)
    this.assignTwitterUserDetails(userAttributes);
  }

  assignTwitterUserDetails = (twitterUserDetails) => {
    return (
      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
          athlete_first_name: twitterUserDetails.first_name,
          athlete_last_name: twitterUserDetails.last_name,
          athlete_email: twitterUserDetails.email,
          twitter_id: twitterUserDetails.twitter_id,
        },
        twitterUserDetails: {
          ...twitterUserDetails
        }
      }))
    )
  }

  handleInputChange = (event) => {
    const { value, name } = event.target;

    if (name === "role") {
      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
          role: value,
          athlete_first_name: state.input.parent_first_name,
          athlete_last_name: state.input.parent_last_name,
          athlete_email: state.input.parent_email,
          athlete_phone_number: state.input.parent_phone_number,
          parent_first_name: state.input.athlete_first_name,
          parent_last_name: state.input.athlete_last_name,
          parent_email: state.input.athlete_email,
          parent_phone_number: state.input.athlete_phone_number,
        }
      }), () => { this.updateFieldErrorMessage(name, value) });
    } else {
      this.setState(state => ({
        ...state,
        input: {
          ...state.input,
          [name]: value
        }
      }), () => { this.updateFieldErrorMessage(name, value) });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { updateOnboardingForm } = this.props;
    const { input } = this.state;
    const isAthlete = input.role === 'athlete';

    if (this.isFormValid()) {
      this.setState({ isSubmitting: true })

      API.createTwitterMaintainer(this.getMaintainerData())
      .then(response => {
        this.setState({ isSubmitting: false })

        if (response.jwt) {
          // Update onboarding form
          updateOnboardingForm({
            athlete_first_name: input.athlete_first_name,
            athlete_last_name: input.athlete_last_name,
            invitee_email: isAthlete ? input.parent_email : input.athlete_email
          });

          this.logInUser(response.user, response.jwt);
        } else {
          if(response.errors.some(error => error.includes('has already been taken'))) {
            this.setFlashMessage('error', (
              <span>
                The email you are trying to sign up with is already associated with another account. Please try <Link to="/log-in" className="text-link">logging in</Link> with email or Facebook or enter a different email.
              </span>
            ))
          } else {
            this.setFlashMessage('error', (
              <span>
                Error: {response.errors[0]}. Please try <Link to="/sign-up" className="text-link">signing up</Link> again.
              </span>
            ))
          }
        }
      })

    } else {
      this.setFormErrorState();
    }
  }

  getMaintainerData = () => {
    const { input } = this.state;

    return {
      role: input.role,
      twitter_id: input.twitter_id,
      athlete_email: input.athlete_email,
      athlete_first_name: input.athlete_first_name,
      athlete_last_name: input.athlete_last_name,
      athlete_phone_number: getStrippedNumberFromString(input.athlete_phone_number),
      parent_email: input.parent_email,
      parent_first_name: input.parent_first_name,
      parent_last_name: input.parent_last_name,
      parent_phone_number: getStrippedNumberFromString(input.parent_phone_number)
    }
  }

  setFormErrorState = () => {
    const { input, displayErrorMessages } = this.state;

    Object.keys(input).map((field, i) => {
      return this.updateFieldErrorMessage(field, input[field])
    })

    if (!this.state.formIsValid && !displayErrorMessages) {
      this.toggleErrorMessages();
    }
  }

  toggleErrorMessages() {
    const { displayErrorMessages } = this.state;

    this.setState(state => ({
      ...state,
      displayErrorMessages: !displayErrorMessages
    }));
  }

  isFormValid() {
    const { input } = this.state;

    let inputErrorIndex = Object.keys(input).map((field, i) => {
      return this.isFieldValid(field, input[field])
    }).indexOf(false)

    if (inputErrorIndex > -1) {
      return false;
    } else {
      return true;
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'phone_number':
        return isValidPhoneNumber(value)
      default:
        return value.length > 0
        // eslint-disable-next-line no-unreachable
        break;
    }
  }

  updateFieldErrorMessage = (fieldName, value) => {
    let errorMessage = '';

    switch(fieldName) {
      case 'phone_number':
        errorMessage = isValidPhoneNumber(value)
        ? ''
        : 'Please enter a valid phone number'
        break;
      case 'role':
        break;
      default:
        errorMessage = value.length > 0
          ? ''
          : 'Please complete this field';
        break;
    }

    this.setState(state => ({
      ...state,
      formErrors: {
        ...state.formErrors,
        [fieldName]: errorMessage
      }
    }));
  }

  setSignUpError(message) {
    this.setState({
      signUpErrorMessage: message
    });
  }

  setFlashMessage(status, message) {
    this.setState(state => ({
      ...state,
      flashMessage: {
        status,
        message
      }
    }));
  }

  renderFlashMessage() {
    const { message, status } = this.state.flashMessage;

    return (
      <FlashMessage optionalClasses={status === 'error' ? 'error' : ''}>
        {message}
      </FlashMessage>
    )
  }

  renderParentSpecificFields() {
    const {
      input,
      formErrors,
      displayErrorMessages,
    } = this.state;

    return (
      <Fragment>
        <FormInput
          label="First Name"
          placeholder="First Name"
          name="parent_first_name"
          type="text"
          value={input.parent_first_name}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.parent_first_name}
        />
        <FormInput
          label="Last Name"
          placeholder="Last Name"
          name="parent_last_name"
          type="text"
          value={input.parent_last_name}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.parent_last_name}
        />
        <FormInput
          label="Email Address"
          placeholder="Email Address"
          name="parent_email"
          type="text"
          value={input.parent_email}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          showError={displayErrorMessages}
          errorMessage={formErrors.parent_email}
        />
        <MaskedFormInput
          label="Mobile Phone"
          name="parent_phone_number"
          mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          placeholder="(555) 555-5555"
          placeholderChar={'\u2000'}
          guide={true}
          type="tel"
          value={input.parent_phone_number}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.parent_phone_number}
        />
      </Fragment>
    )
  }

  renderAthleteSpecificFields() {
    const {
      input,
      formErrors,
      displayErrorMessages,
    } = this.state;

    return (
      <Fragment>
        <FormInput
          label="First Name"
          placeholder="First Name"
          name="athlete_first_name"
          type="text"
          value={input.athlete_first_name}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_first_name}
        />
        <FormInput
          label="Last Name"
          placeholder="Last Name"
          name="athlete_last_name"
          type="text"
          value={input.athlete_last_name}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_last_name}
        />
        <FormInput
          label="Email Address"
          placeholder="Email Address"
          name="athlete_email"
          type="text"
          value={input.athlete_email}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_email}
        />
        <MaskedFormInput
          label="Mobile Phone"
          name="athlete_phone_number"
          mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          placeholder="(555) 555-5555"
          placeholderChar={'\u2000'}
          guide={true}
          type="tel"
          value={input.athlete_phone_number}
          onChange={this.handleInputChange}
          showError={displayErrorMessages}
          errorMessage={formErrors.athlete_phone_number}
        />
      </Fragment>
    )
  }

  render() {
    const {
      input,
      formErrors,
      options,
      isLoading,
      isSubmitting,
    } = this.state;
    const { appName } = this.props;
    const isParent = input.role === 'parent';

    return isLoading
    ? (
      <AppCanvasLoader />
    )
    : (
      <div className="onboarding-complete-social-sign-up">
        <Helmet>
          <title>{appName} | Complete Social Sign Up</title>
        </Helmet>
        <header>
          <h2>Sign Up for Locker Linked</h2>
          {this.renderFlashMessage()}
        </header>
        <form onSubmit={this.handleSubmit}>
          <SelectFormInput
            label='I am a'
            name='role'
            value={input.role}
            onChange={this.handleInputChange}
            errorMessage={formErrors.role}
            optionalClasses="select-container"
            selectOptions={options.role}
          >
            {
              input.role === 'parent' &&
              <p className="note">
                Sign up as yourself, using your own email address. You will have the opportunity to maintain an existing profile or create a new one in the next steps.
              </p>
            }
          </SelectFormInput>
          { isParent
            ? this.renderParentSpecificFields()
            : this.renderAthleteSpecificFields()
          }
          <hr />
          <label className="emphasized-label">
            { isParent
              ? 'Athlete Information'
              : 'Parent/Guardian Information'
            }
          </label>
          { isParent
            ? this.renderAthleteSpecificFields()
            : this.renderParentSpecificFields()
          }
          <hr />
          <input
            type="submit"
            value="Continue"
            disabled={isSubmitting}
          />
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    onboarding: state.onboarding
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    socialLogIn: (user) => dispatch(socialLogIn(user)),
    setActiveProfile: (username) => dispatch(setActiveProfile(username)),
    setReduxAccountDetails: (user, username) => dispatch(getProfileAccountDetails(user, username)),
    updateReduxUser: (user) => dispatch(updateUserState(user)),
    updateOnboardingForm: formData => dispatch(updateForm(formData)),
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteTwitterSignUpForm))



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/CompleteTwitterSignUpForm.js